module.exports = __webpack_public_path__ + "static/appStore-74a6a8b5450759249aa0e2910f10b2b9.png";